module.exports = function (area) {
    return {
        event: 'BWSAUFirstAvailableWindow',
        eventContext: {
            area
        }
    };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/delivery/atmmapper/first-available-window-mapper.js
 **/